<template>
   <div v-if="showBanner" class="cookie-modal">
      <p class="cookie-modal__text">
         Barsel.media обрабатывает файлы cookie. Они помогают нам делать этот сайт удобнее для пользователей.
         Продолжая работу с сайтом barsel.media, <a href="#">вы соглашаетесь с обработкой файлов cookie</a> вашего
         браузера. Однако вы можете запретить обработку некоторых типов файлов cookie в настройках вашего браузера .
      </p>
      <button @click="acceptCookies">
         Хорошо
      </button>
   </div>

</template>
<script setup>
import { onMounted, ref, } from 'vue';

const showBanner = ref(false)
const acceptCookies = () => {
   // Устанавливаем флаг в localStorage
   localStorage.setItem('cookiesAccepted', 'true');
   showBanner.value = false; // Скрываем баннер
}
onMounted(() => {
   // Проверяем, принял ли пользователь куки
   const cookiesAccepted = localStorage.getItem('cookiesAccepted');
   if (!cookiesAccepted) {
      showBanner.value = true; // Показываем баннер, если куки не приняты
   }
})
</script>


<style lang="scss">
.cookie-modal {
   width: 100%;
   position: fixed;
   bottom: 38px;
   z-index: 50;
   max-width: calc(100vw - 144px);
   left: 50%;
   translate: -50% 0;
   // .cookie-modal__text
   display: flex;
   gap: 15px;
   align-items: center;
   justify-content: space-between;
   border-radius: 16px;
   background-color: #E1E1E1;
   padding: 32px 48px;

   @media(max-width: 568px) {
      max-width: calc(100vw - 32px);
      padding: 18px 16px;
      flex-direction: column;
      gap: 20px;
      align-items: flex-start;
      bottom: 16px;
   }

   &__text {
      color: #262F44;
      max-width: 1359px;
      font-weight: 400;
      font-size: 24px;
      line-height: 110.00000000000001%;

      a {
         color: #262F44;
         text-decoration: underline;
      }

      @media(max-width: 568px) {
         font-size: 16px;
      }
   }

   button {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 18px;
      border: 1px solid #262F44;
      border-radius: 11px;
      font-weight: 400;
      font-size: 22px;
      line-height: 120%;
      letter-spacing: 1%;
      color: #262F44;

   }
}
</style>